import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth, formatApiError } from "../AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/app", { replace: true });
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#0a0a0a]" data-testid="member-login-page">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-8 shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-light text-[#C97654] mb-2">Welcome Back</h1>
          <p className="text-[#E8DCC4]/60 text-sm">Sign in to your Passion Pilates account</p>
        </div>

        {error && (
          <div data-testid="login-error" className="mb-4 bg-[#8B2635]/20 border border-[#8B2635] rounded-lg px-4 py-3 text-[#FFB89A] text-sm">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block text-[#E8DCC4]/80 text-sm mb-2 font-medium">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="w-full bg-[#0a0a0a] border-2 border-[#2a2a2a] focus:border-[#C97654] rounded-lg px-4 py-3 text-[#E8DCC4] placeholder-[#E8DCC4]/30 transition-colors outline-none"
              placeholder="your@email.com"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="block text-[#E8DCC4]/80 text-sm mb-2 font-medium">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="w-full bg-[#0a0a0a] border-2 border-[#2a2a2a] focus:border-[#C97654] rounded-lg px-4 py-3 text-[#E8DCC4] placeholder-[#E8DCC4]/30 transition-colors outline-none"
              placeholder="Your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            data-testid="login-submit-btn"
            className="w-full bg-gradient-to-r from-[#C97654] to-[#FF9472] hover:from-[#FF9472] hover:to-[#FFB89A] text-white py-3 rounded-lg font-bold transition-all duration-300 shadow-md disabled:opacity-50"
          >
            {submitting ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="mt-6 flex items-center justify-between text-sm">
          <Link to="/app/forgot-password" className="text-[#C97654] hover:text-[#FF9472] transition-colors">
            Forgot password?
          </Link>
          <Link to="/app/register" data-testid="login-link-register" className="text-[#E8DCC4]/70 hover:text-[#C97654] transition-colors">
            Create account →
          </Link>
        </div>
      </div>
    </div>
  );
}
